module.exports = __webpack_public_path__ + "img/mobile_app_banner_mobile_fr.84c4b4ac.png";